var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"avatar",class:{ 'avatar--full': _vm.full },style:(_vm.styles)},'div',_vm.$attrs,false),[_c('span',[_vm._v(_vm._s(_vm.avatar ? "" : _vm.initals))])])}
var staticRenderFns = []

export { render, staticRenderFns }